
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.53.47a.75.75 0 010 1.06l-6 6a.75.75 0 01-1.06 0l-6-6A.75.75 0 111.53.47L7 5.94 12.47.47a.75.75 0 011.06 0z","fill":"#363636"}})])
          )
        }
      }
    